import React from "react";
import { Link } from "components/common";
import ForwarderRoutes from "../../Routes";
const ForwarderCell = ({ forwarderId = void 0, forwarderTitle = void 0 }) => {
  if (!forwarderId) {
    return /* @__PURE__ */ React.createElement("em", null, "No forwarder");
  }
  return /* @__PURE__ */ React.createElement(Link, { to: ForwarderRoutes.details(forwarderId) }, forwarderTitle || forwarderId);
};
export default ForwarderCell;
